var _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#e60000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.304 7.527l-6.09-6.092c-.25-.334-.19-.805.136-1.066.12-.142.294-.23.48-.24.187-.01.37.056.505.184l6.094 6.091-1.125 1.123z",
    transform: "translate(1.667 3.333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.544 5.54l-6.38 6.38c-.249.334-.188.805.138 1.065.12.143.294.23.48.241.187.01.37-.056.505-.184l6.38-6.38-1.123-1.123z",
    transform: "translate(1.667 3.333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.752 5.952H.744C.546 5.96.36 6.05.23 6.2c-.13.15-.19.349-.167.546-.017.403.281.75.681.794h14.008V5.952z",
    transform: "translate(1.667 3.333)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.bde42911b3fe55d187c33c2bd869b0aa.svg";
export { ForwardRef as ReactComponent };